import { useReportDateAccess, useReportDateState } from "../hooks/useReportDateAccess";
// // src/pages/SalesListPage.jsx
// import React, { useState, useEffect, useMemo, useRef } from "react";
// import styled from "styled-components";
// import html2pdf from "html2pdf.js";
// import {
//   FaCalendarAlt,
//   FaDownload,
//   FaArrowLeft,
//   FaEye,
//   FaFileInvoice,
//   FaSearch,
//   FaSyncAlt,
//   FaChartLine,
//   FaMoneyBillWave,
//   FaClipboardList,
// } from "react-icons/fa";
// import { Link, useNavigate } from "react-router-dom";

// const color = {
//   brand: "var(--app-primary)",
//   brandSoft: "var(--app-primary-soft)",
//   text: "#111827",
//   muted: "#6B7280",
//   line: "#E5E7EB",
//   bg: "#F2F5F9",
//   white: "#fff",
//   success: "#2e7d32",
//   orange: "#ea580c",
// };

// const SalesListPage = () => {
//   const navigate = useNavigate();
//   const reportRef = useRef();

//   const [salesData, setSalesData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [refreshing, setRefreshing] = useState(false);
//   const [error, setError] = useState("");
//   const [restaurant, setRestaurant] = useState({});
//   const [fromDate, setFromDate] = useState(
//     new Date().toISOString().slice(0, 10)
//   );
//   const [toDate, setToDate] = useState(new Date().toISOString().slice(0, 10));
//   const [search, setSearch] = useState("");

//   const presets = useMemo(() => {
//     const today = new Date();
//     const toISO = (d) => d.toISOString().slice(0, 10);
//     const clone = (d) => new Date(d.getTime());
//     const startOfWeek = () => {
//       const t = new Date();
//       const day = t.getDay(); // 0 sun
//       const diff = t.getDate() - day + (day === 0 ? -6 : 1); // monday
//       t.setDate(diff);
//       return t;
//     };
//     const startOfMonth = () => {
//       const t = new Date();
//       t.setDate(1);
//       return t;
//     };
//     const yesterday = () => {
//       const t = new Date();
//       t.setDate(t.getDate() - 1);
//       return t;
//     };
//     return [
//       {
//         label: "Today",
//         from: toISO(today),
//         to: toISO(today),
//       },
//       {
//         label: "Yesterday",
//         from: toISO(yesterday()),
//         to: toISO(yesterday()),
//       },
//       {
//         label: "This Week",
//         from: toISO(startOfWeek()),
//         to: toISO(today),
//       },
//       {
//         label: "This Month",
//         from: toISO(startOfMonth()),
//         to: toISO(today),
//       },
//     ];
//   }, []);

//   // load restaurant info once
//   useEffect(() => {
//     const u = JSON.parse(localStorage.getItem("userData"))?.data;
//     if (u) setRestaurant(u || {});
//   }, []);

//   // fetch sales whenever dates change
//   useEffect(() => {
//     const fetchSales = async (opts = {}) => {
//       if (opts.refresh) setRefreshing(true);
//       else setLoading(true);
//       setError("");
//       try {
//         const user = JSON.parse(localStorage.getItem("userData"))?.data;
//         if (!user?.id) throw new Error("No user ID");
//         const res = await fetch(
//           "https://qr.billsarthi.in/public/api/getorderlist",
//           {
//             method: "POST",
//             headers: { "Content-Type": "application/json" },
//             body: JSON.stringify({
//               restaurantid: user.id,
//               fromdate: fromDate,
//               todate: toDate,
//             }),
//           }
//         );
//         const json = await res.json();
//         if (!res.ok) throw new Error(json?.message || "Failed to load sales");
//         setSalesData(json.list || []);
//       } catch (e) {
//         console.error(e);
//         setError(e.message || "Unable to load sales");
//         setSalesData([]);
//       } finally {
//         if (opts.refresh) setRefreshing(false);
//         else setLoading(false);
//       }
//     };
//     fetchSales();
//   }, [fromDate, toDate]);

//   // filter by search (id / table / amount)
//   const filtered = useMemo(() => {
//     const q = search.trim().toLowerCase();
//     if (!q) return salesData;
//     return salesData.filter((o) => {
//       const id = String(o.id || "").toLowerCase();
//       const table = String(o.tableid || "").toLowerCase();
//       const amt = String(o.totalamount || "").toLowerCase();
//       return id.includes(q) || table.includes(q) || amt.includes(q);
//     });
//   }, [salesData, search]);

//   // totals
//   const totals = useMemo(() => {
//     const totalAmount = filtered.reduce(
//       (s, o) => s + (Number(o.totalamount) || 0),
//       0
//     );
//     const average = filtered.length ? totalAmount / filtered.length : 0;
//     const maxOrder = filtered.reduce(
//       (m, o) =>
//         !m || Number(o.totalamount || 0) > Number(m.totalamount || 0) ? o : m,
//       null
//     );
//     return {
//       count: filtered.length,
//       totalAmount,
//       average,
//       maxOrder,
//     };
//   }, [filtered]);

//   // Export the report table to PDF
//   const exportPDF = () => {
//     if (!reportRef.current || filtered.length === 0) return;
//     const opt = {
//       margin: [10, 10, 14, 10],
//       filename: `sales_${fromDate}_to_${toDate}.pdf`,
//       html2canvas: { scale: 2 },
//       jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
//       pagebreak: { mode: ["css", "legacy"] },
//     };
//     html2pdf().set(opt).from(reportRef.current).save();
//   };

//   // navigate to dynamic receipt page
//   const viewReceipt = (order) => {
//     navigate(`/receipt/${order.id}`, { state: { order } });
//   };

//   const fmtDate = (d) =>
//     new Date(d).toLocaleDateString(undefined, {
//       day: "2-digit",
//       month: "short",
//       year: "numeric",
//     });
//   const fmtINR = (n) => `₹ ${Number(n || 0).toFixed(2)}`;
//   const fmtTime = (d) =>
//     new Date(d).toLocaleTimeString(undefined, { hour: "2-digit", minute: "2-digit" });

//   return (
//     <Wrap>
//       {/* Header Bar */}
//       <Header>
//         <HeaderLeft onClick={() => navigate(-1)}>
//           <FaArrowLeft />
//           <span>Back</span>
//         </HeaderLeft>
//         <HeaderTitle>Sales</HeaderTitle>
//         <HeaderRight>
//           <ExportBtn onClick={exportPDF} disabled={filtered.length === 0}>
//             <FaDownload />
//             <span>Export PDF</span>
//           </ExportBtn>
//         </HeaderRight>
//       </Header>

//       {/* Filters Card */}
//       <Card>
//         <CardTitle>Filters</CardTitle>
//         <FiltersRow>
//           <FilterBox>
//             <label>
//               <FaCalendarAlt /> From
//             </label>
//             <input
//               type="date"
//               value={fromDate}
//               max={toDate}
//               onChange={(e) => setFromDate(e.target.value)}
//             />
//           </FilterBox>

//           <FilterBox>
//             <label>
//               <FaCalendarAlt /> To
//             </label>
//             <input
//               type="date"
//               value={toDate}
//               min={fromDate}
//               onChange={(e) => setToDate(e.target.value)}
//             />
//           </FilterBox>

//           <SearchBox>
//             <FaSearch />
//             <input
//               placeholder="Search by ID / Table / Amount"
//               value={search}
//               onChange={(e) => setSearch(e.target.value)}
//             />
//           </SearchBox>
//         </FiltersRow>
//         <QuickRow>
//           {presets.map((p) => (
//             <QuickChip
//               key={p.label}
//               $active={fromDate === p.from && toDate === p.to}
//               onClick={() => {
//                 setFromDate(p.from);
//                 setToDate(p.to);
//               }}
//             >
//               {p.label}
//             </QuickChip>
//           ))}
//           <RefreshBtn onClick={() => setFromDate((d) => d)}>
//             <FaSyncAlt />
//             {refreshing ? "Refreshing..." : "Refresh"}
//           </RefreshBtn>
//         </QuickRow>

//         {/* Totals strip */}
//         <SummaryGrid>
//           <SummaryCard>
//             <div className="icon brand">
//               <FaClipboardList />
//             </div>
//             <div>
//               <small>Total Orders</small>
//               <h3>{totals.count}</h3>
//               <span>{fromDate} → {toDate}</span>
//             </div>
//           </SummaryCard>
//           <SummaryCard>
//             <div className="icon green">
//               <FaMoneyBillWave />
//             </div>
//             <div>
//               <small>Total Amount</small>
//               <h3>{fmtINR(totals.totalAmount)}</h3>
//               <span>Incl. all orders in range</span>
//             </div>
//           </SummaryCard>
//           <SummaryCard>
//             <div className="icon orange">
//               <FaChartLine />
//             </div>
//             <div>
//               <small>Avg. Order</small>
//               <h3>{fmtINR(totals.average)}</h3>
//               <span>{totals.count} orders</span>
//             </div>
//           </SummaryCard>
//         </SummaryGrid>
//         {totals.maxOrder ? (
//           <Highlight>
//             <div className="label">Highest bill</div>
//             <div className="value">{fmtINR(totals.maxOrder.totalamount)}</div>
//             <div className="meta">
//               Table {totals.maxOrder.tableid || "-"} · {fmtDate(totals.maxOrder.created_at)} ·{" "}
//               {fmtTime(totals.maxOrder.created_at)}
//             </div>
//           </Highlight>
//         ) : null}
//       </Card>

//       {/* Report Card */}
//       <Card ref={reportRef}>
//         <ReportHeader>
//           <LogoRow>
//             <FaFileInvoice />
//             <h2>Sales Report</h2>
//           </LogoRow>
//           <div className="meta">
//             <div className="line">{restaurant?.restaurant_name || "-"}</div>
//             <div className="line">{restaurant?.addressline3 || "-"}</div>
//             <div className="line">
//               Phone: {restaurant?.mobile_number || "-"}
//             </div>
//             <div className="line">
//               Period: <b>{fromDate}</b> to <b>{toDate}</b>
//             </div>
//           </div>
//         </ReportHeader>

//         {loading ? (
//           <Center>Loading…</Center>
//         ) : filtered.length === 0 ? (
//           <Center>{error || "No orders found."}</Center>
//         ) : (
//           <TableWrap>
//             <Table>
//               <thead>
//                 <tr>
//                   <th style={{ width: 80 }}>ID</th>
//                   <th>Amount</th>
//                   <th>Table</th>
//                   <th>Date</th>
//                   <th>Time</th>
//                   <th style={{ width: 110 }}>Action</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {filtered.map((o) => (
//                   <tr
//                     key={o.id}
//                     onClick={() => viewReceipt(o)}
//                     style={{ cursor: "pointer" }}
//                   >
//                     <td>{o.id}</td>
//                     <td>{fmtINR(o.totalamount)}</td>
//                     <td>{o.tableid}</td>
//                     <td>{fmtDate(o.created_at)}</td>
//                     <td>{fmtTime(o.created_at)}</td>
//                     <td onClick={(e) => e.stopPropagation()}>
//                       <LinkBtn to={`/receipt/${o.id}`} state={{ order: o }}>
//                         <FaEye /> View
//                       </LinkBtn>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//               <tfoot>
//                 <tr>
//                   <td colSpan={1}>
//                     <b>Totals</b>
//                   </td>
//                   <td>
//                     <b>{fmtINR(totals.totalAmount)}</b>
//                   </td>
//                   <td colSpan={3}></td>
//                 </tr>
//               </tfoot>
//             </Table>
//           </TableWrap>
//         )}
//       </Card>
//     </Wrap>
//   );
// };

// export default SalesListPage;

// /* ---------------- styled ---------------- */
// const Wrap = styled.div`
//   font-family: system-ui, -apple-system, Segoe UI, Roboto, Inter, Arial;
//   background: ${color.bg};
//   min-height: 100vh;
//   padding-bottom: 32px;
// `;

// const Header = styled.header`
//   display: grid;
//   grid-template-columns: 1fr auto 1fr;
//   align-items: center;
//   background: ${color.brand};
//   color: #fff;
//   padding: 12px 18px;
//   position: sticky;
//   top: 0;
//   z-index: 5;
//   `;
// const HeaderLeft = styled.button`
//   justify-self: start;
//   display: inline-flex;
//   align-items: center;
//   gap: 8px;
//   background: transparent;
//   color: #fff;
//   border: 0;
//   font-weight: 700;
//   cursor: pointer;
// `;
// const HeaderTitle = styled.h1`
//   margin: 0;
//   text-align: center;
//   font-size: 1.2rem;
//   letter-spacing: 0.3px;
//   font-weight: 900;
// `;
// const HeaderRight = styled.div`
//   justify-self: end;
// `;
// const ExportBtn = styled.button`
//   display: inline-flex;
//   align-items: center;
//   gap: 8px;
//   background: ${color.success};
//   border: 0;
//   color: #fff;
//   padding: 8px 12px;
//   border-radius: 10px;
//   font-weight: 800;
//   cursor: pointer;
//   opacity: ${(p) => (p.disabled ? 0.6 : 1)};
// `;

// const Card = styled.div`
//   background: ${color.white};
//   border-radius: 16px;
//   padding: 16px;
//   margin: 16px;
//   border: 1px solid ${color.line};
//   box-shadow: 0 4px 16px rgba(2, 44, 77, 0.06);
// `;
// const CardTitle = styled.h2`
//   margin: 2px 2px 12px;
//   color: ${color.muted};
//   font-size: 0.95rem;
//   text-transform: uppercase;
//   letter-spacing: 0.6px;
// `;

// const FiltersRow = styled.div`
//   display: grid;
//   grid-template-columns: repeat(3, 1fr);
//   gap: 12px;
//   @media (max-width: 860px) {
//     grid-template-columns: 1fr;
//   }
// `;
// const FilterBox = styled.div`
//   display: grid;
//   gap: 6px;
//   label {
//     color: ${color.text};
//     font-weight: 700;
//     display: flex;
//     align-items: center;
//     gap: 6px;
//   }
//   input {
//     height: 44px;
//     border: 1px solid ${color.line};
//     border-radius: 10px;
//     padding: 0 12px;
//     background: #f9f9f9;
//     color: ${color.text};
//   }
// `;
// const SearchBox = styled.div`
//   display: grid;
//   gap: 6px;
//   align-items: center;
//   grid-template-columns: 20px 1fr;
//   padding: 0 10px;
//   border: 1px solid ${color.line};
//   border-radius: 10px;
//   background: #f9f9f9;
//   color: ${color.text};
//   input {
//     height: 44px;
//     border: 0;
//     background: transparent;
//     color: ${color.text};
//     padding-left: 6px;
//     font-size: 14px;
//   }
// `;

// const QuickRow = styled.div`
//   display: flex;
//   flex-wrap: wrap;
//   gap: 10px;
//   margin-top: 10px;
//   align-items: center;
// `;
// const QuickChip = styled.button`
//   border: 1px solid ${color.line};
//   background: ${({ $active }) => ($active ? color.brand : "#f5f7fb")};
//   color: ${({ $active }) => ($active ? "#fff" : color.text)};
//   border-radius: 999px;
//   padding: 8px 12px;
//   font-weight: 700;
//   cursor: pointer;
//   transition: all 0.15s ease;
//   &:hover {
//     box-shadow: 0 4px 10px rgba(0, 0, 0, 0.06);
//   }
// `;
// const RefreshBtn = styled.button`
//   border: 1px solid ${color.brand};
//   background: ${color.brandSoft};
//   color: ${color.brand};
//   border-radius: 10px;
//   padding: 8px 12px;
//   display: inline-flex;
//   align-items: center;
//   gap: 8px;
//   font-weight: 800;
//   cursor: pointer;
// `;

// const SummaryGrid = styled.div`
//   display: grid;
//   grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
//   gap: 12px;
//   margin-top: 14px;
// `;
// const SummaryCard = styled.div`
//   background: #f9fbff;
//   border: 1px solid ${color.line};
//   border-radius: 14px;
//   padding: 14px;
//   display: flex;
//   align-items: center;
//   gap: 12px;
//   small {
//     color: ${color.muted};
//     font-weight: 700;
//     text-transform: uppercase;
//     letter-spacing: 0.6px;
//     font-size: 11px;
//   }
//   h3 {
//     margin: 2px 0 0;
//     font-size: 1.4rem;
//     color: ${color.text};
//   }
//   span {
//     color: ${color.muted};
//     font-size: 0.9rem;
//   }
//   .icon {
//     width: 42px;
//     height: 42px;
//     border-radius: 12px;
//     display: grid;
//     place-items: center;
//     color: #fff;
//     &.brand {
//       background: ${color.brand};
//     }
//     &.green {
//       background: ${color.success};
//     }
//     &.orange {
//       background: ${color.orange};
//     }
//   }
// `;

// const Highlight = styled.div`
//   margin-top: 10px;
//   padding: 12px 14px;
//   border-radius: 12px;
//   background: #fff7ed;
//   border: 1px solid #fed7aa;
//   display: flex;
//   align-items: center;
//   gap: 10px;
//   flex-wrap: wrap;
//   .label {
//     color: #9a3412;
//     font-weight: 800;
//   }
//   .value {
//     font-weight: 900;
//     color: ${color.text};
//   }
//   .meta {
//     color: ${color.muted};
//   }
// `;

// const ReportHeader = styled.div`
//   display: flex;
//   align-items: flex-start;
//   justify-content: space-between;
//   gap: 16px;
//   margin-bottom: 10px;
//   .meta .line {
//     color: ${color.muted};
//   }
//   @media (max-width: 720px) {
//     flex-direction: column;
//   }
// `;
// const LogoRow = styled.div`
//   display: flex;
//   align-items: center;
//   gap: 10px;
//   h2 {
//     margin: 0;
//   }
// `;

// const TableWrap = styled.div`
//   width: 100%;
//   overflow-x: auto;
//   border-radius: 12px;
//   border: 1px solid ${color.line};
// `;
// const Table = styled.table`
//   width: 100%;
//   border-collapse: collapse;
//   background: #fff;

//   thead {
//     background: ${color.brandSoft};
//   }
//   th,
//   td {
//     padding: 10px 12px;
//     border-bottom: 1px solid ${color.line};
//     text-align: left;
//     font-size: 14px;
//   }
//   tbody tr:hover {
//     background: #fafcff;
//   }
//   tfoot td {
//     background: #fcfcff;
//   }
// `;

// const Center = styled.div`
//   text-align: center;
//   padding: 40px;
//   color: ${color.muted};
// `;

// const LinkBtn = styled(Link)`
//   display: inline-flex;
//   align-items: center;
//   gap: 6px;
//   background: ${color.brandSoft};
//   border: 1px solid ${color.brand};
//   color: ${color.brand};
//   padding: 6px 10px;
//   border-radius: 10px;
//   font-weight: 800;
//   text-decoration: none;
// `;

// src/pages/SalesListPage.jsx
import React, { useState, useEffect, useMemo, useRef } from "react";
import { API_ENDPOINTS } from "../config/constants";
import { localToday, toLocalYmd } from "../utils/localDate";
import styled from "styled-components";
import {
  FaCalendarAlt,
  FaDownload,
  FaFileExcel,
  FaArrowLeft,
  FaEye,
  FaFileInvoice,
  FaSearch,
  FaSyncAlt,
  FaChartLine,
  FaMoneyBillWave,
  FaClipboardList,
} from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import { downloadExcel, downloadPDF, printThermal, printThermalViaUsb} from "../utils/exportHelpers";
import { formatStoredMoney } from "../utils/currency";
import { isFullOfflineModeEnabled } from "../utils/fullOfflineMode";

const color = {
  brand: "var(--app-primary)",
  brandSoft: "var(--app-primary-soft)",
  text: "#111827",
  muted: "#6B7280",
  line: "#E5E7EB",
  bg: "#F2F5F9",
  white: "#fff",
  success: "#2e7d32",
  orange: "#ea580c",
};

const SalesListPage = () => {
  const navigate = useNavigate();
  const reportRef = useRef();

  const [salesData, setSalesData] = useState([]);
  const { todayOnly } = useReportDateAccess();
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  const [error, setError] = useState("");
  const [restaurant, setRestaurant] = useState({});
  const [fromDate, setFromDate] = useReportDateState(
    localToday()
  );
  const [toDate, setToDate] = useReportDateState(localToday());
  const [search, setSearch] = useState("");
  const [reloadKey, setReloadKey] = useState(0);

  const presets = useMemo(() => {
    const today = new Date();
    const toISO = (d) => toLocalYmd(d);
    const daysAgo = (days) => {
      const t = new Date();
      t.setDate(t.getDate() - days);
      return t;
    };
    const yesterday = () => {
      const t = new Date();
      t.setDate(t.getDate() - 1);
      return t;
    };
    return [
      {
        label: "Today",
        from: toISO(today),
        to: toISO(today),
      },
      {
        label: "Yesterday",
        from: toISO(yesterday()),
        to: toISO(yesterday()),
      },
      {
        label: "Weekly",
        from: toISO(daysAgo(6)),
        to: toISO(today),
      },
      {
        label: "Monthly",
        from: toISO(daysAgo(29)),
        to: toISO(today),
      },
    ];
  }, []);

  // load restaurant info once
  useEffect(() => {
    const u = JSON.parse(localStorage.getItem("userData"))?.data;
    if (u) setRestaurant(u || {});
  }, []);

  // fetch sales whenever dates change
  useEffect(() => {
    const fetchSales = async (opts = {}) => {
      if (opts.refresh) setRefreshing(true);
      else setLoading(true);
      setError("");
      try {
        const user = JSON.parse(localStorage.getItem("userData"))?.data;
        if (!user?.id) throw new Error("No user ID");
        if (isFullOfflineModeEnabled()) {
          if (!window.desktopOrders?.list) {
            throw new Error("Restart the desktop app to initialize offline sales.");
          }
          const orders = await window.desktopOrders.list({
            restaurantId: String(user.id),
            fromDate,
            toDate,
          });
          setSalesData(Array.isArray(orders) ? orders : []);
          return;
        }
        const res = await fetch(
          API_ENDPOINTS.GET_ORDER_LIST,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              restaurantid: user.id,
              fromdate: fromDate,
              todate: toDate,
            }),
          }
        );
        const json = await res.json();
        if (!res.ok) throw new Error(json?.message || "Failed to load sales");
        setSalesData(json.list || []);
      } catch (e) {
        console.error(e);
        setError(e.message || "Unable to load sales");
        setSalesData([]);
      } finally {
        if (opts.refresh) setRefreshing(false);
        else setLoading(false);
      }
    };
    fetchSales();
  }, [fromDate, toDate, reloadKey]);

  // filter by search (id / table / amount)
  const filtered = useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return salesData;
    return salesData.filter((o) => {
      const id = String(o.id || "").toLowerCase();
      const table = String(o.tableid || "").toLowerCase();
      const amt = String(o.totalamount || "").toLowerCase();
      return id.includes(q) || table.includes(q) || amt.includes(q);
    });
  }, [salesData, search]);

  // totals
  const totals = useMemo(() => {
    const totalAmount = filtered.reduce(
      (s, o) => s + (Number(o.totalamount) || 0),
      0
    );
    const average = filtered.length ? totalAmount / filtered.length : 0;
    const maxOrder = filtered.reduce(
      (m, o) =>
        !m || Number(o.totalamount || 0) > Number(m.totalamount || 0) ? o : m,
      null
    );
    return {
      count: filtered.length,
      totalAmount,
      average,
      maxOrder,
    };
  }, [filtered]);

  // Restaurant display fields for header
  const restaurantName =
    restaurant.restaurant_name ||
    restaurant.restaurantname ||
    restaurant.name ||
    "Restaurant";

  const restaurantPhone =
    restaurant.mobile_number ||
    restaurant.mobile ||
    restaurant.phone ||
    restaurant.contactnumber ||
    "";

  const restaurantAddress =
    restaurant.addressline3 ||
    restaurant.address ||
    restaurant.restaurantaddress ||
    restaurant.city ||
    "";

  const generatedOn = useMemo(
    () =>
      new Date().toLocaleString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      }),
    []
  );

  // Export the report table to PDF
  const exportExcel = () => {
    if (filtered.length === 0) return;
    const headers = [
      "#",
      "Bill No",
      "Date/Time",
      "Table / Type",
      "Customer",
      "Phone",
      "Payment Mode",
      "Total Amount",
    ];
    const rows = filtered.map((row, idx) => [
      row.sno || idx + 1,
      row.billno || "-",
      row.created_at ? `${fmtDate(row.created_at)} ${fmtTime(row.created_at)}` : "-",
      row.table_name || row.ordertype || "-",
      row.customer_name || "Walk-in",
      row.customer_phone || "-",
      row.payment_mode || "Cash",
      row.totalamount || row.bill_amount || 0,
    ]);
    downloadExcel(`sales_${fromDate}_to_${toDate}.xlsx`, headers, rows);
  };

  const exportPDF = () => {
    if (!reportRef.current || filtered.length === 0) return;
    downloadPDF(reportRef.current, `sales_${fromDate}_to_${toDate}.pdf`);
  };

  // navigate to dynamic receipt page
  const viewReceipt = (order) => {
    navigate(`/receipt/${order.id}`, { state: { order } });
  };

  const fmtDate = (d) =>
    new Date(d).toLocaleDateString(undefined, {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  const fmtINR = formatStoredMoney;
  const fmtTime = (d) =>
    new Date(d).toLocaleTimeString(undefined, {
      hour: "2-digit",
      minute: "2-digit",
    });

  return (
    <Wrap>
      {/* Header Bar */}
      <Header>
        <HeaderLeft onClick={() => navigate(-1)}>
          <FaArrowLeft />
          <span>Back</span>
        </HeaderLeft>
        <HeaderTitle>Sales</HeaderTitle>
        <HeaderRight>
          <ExportBtn onClick={exportExcel} disabled={filtered.length === 0}>
            <FaFileExcel />
            <span>Export Excel</span>
          </ExportBtn>
          <ExportBtn onClick={exportPDF} disabled={filtered.length === 0}>
            <FaDownload />
            <span>Export PDF</span>
          </ExportBtn>
          <ExportBtn
            onClick={() => printThermal(reportRef.current, `sales_list_${fromDate}_to_${toDate}`)}
            disabled={filtered.length === 0}
          >
            <span>Thermal Print</span>
          </ExportBtn><ExportBtn
            onClick={() => printThermalViaUsb(reportRef.current, `sales_list_${fromDate}_to_${toDate}`)}
            disabled={filtered.length === 0}
          >
            <span>Thermal Print via USB</span>
          </ExportBtn>
        </HeaderRight>
      </Header>

      {/* Filters Card */}
      <Card>
        <CardTitle>{todayOnly ? "Filters · Today only" : "Filters"}</CardTitle>
        <FiltersRow>
          <FilterBox>
            <label>
              <FaCalendarAlt /> From
            </label>
            <input
              type="date"
              value={fromDate}
              max={toDate}
              disabled={todayOnly}
              onChange={(e) => setFromDate(e.target.value)}
            />
          </FilterBox>

          <FilterBox>
            <label>
              <FaCalendarAlt /> To
            </label>
            <input
              type="date"
              value={toDate}
              min={fromDate}
              disabled={todayOnly}
              onChange={(e) => setToDate(e.target.value)}
            />
          </FilterBox>

          <SearchBox>
            <FaSearch />
            <input
              placeholder="Search by ID / Table / Amount"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </SearchBox>
        </FiltersRow>
        <QuickRow>
          {presets.filter((p) => !todayOnly || (p.from === fromDate && p.to === toDate)).map((p) => (
            <QuickChip
              key={p.label}
              $active={fromDate === p.from && toDate === p.to}
              onClick={() => {
                setFromDate(p.from);
                setToDate(p.to);
              }}
            >
              {p.label}
            </QuickChip>
          ))}
          <RefreshBtn onClick={() => setReloadKey((value) => value + 1)}>
            <FaSyncAlt />
            {refreshing ? "Refreshing..." : "Refresh"}
          </RefreshBtn>
        </QuickRow>

        {/* Totals strip */}
        <SummaryGrid>
          <SummaryCard>
            <div className="icon brand">
              <FaClipboardList />
            </div>
            <div>
              <small>Total Orders</small>
              <h3>{totals.count}</h3>
              <span>
                {fromDate} → {toDate}
              </span>
            </div>
          </SummaryCard>
          <SummaryCard>
            <div className="icon green">
              <FaMoneyBillWave />
            </div>
            <div>
              <small>Total Amount</small>
              <h3>{fmtINR(totals.totalAmount)}</h3>
              <span>Incl. all orders in range</span>
            </div>
          </SummaryCard>
          <SummaryCard>
            <div className="icon orange">
              <FaChartLine />
            </div>
            <div>
              <small>Avg. Order</small>
              <h3>{fmtINR(totals.average)}</h3>
              <span>{totals.count} orders</span>
            </div>
          </SummaryCard>
        </SummaryGrid>
        {totals.maxOrder ? (
          <Highlight>
            <div className="label">Highest bill</div>
            <div className="value">{fmtINR(totals.maxOrder.totalamount)}</div>
            <div className="meta">
              Table {totals.maxOrder.tableid || "-"} ·{" "}
              {fmtDate(totals.maxOrder.created_at)} ·{" "}
              {fmtTime(totals.maxOrder.created_at)}
            </div>
          </Highlight>
        ) : null}
      </Card>

      {/* Report Card (PDF content) */}
      <Card ref={reportRef}>
        {/* PDF Header Card */}
        <PdfHeaderCard>
          <ReportHeader>
            <div className="left">
              <div className="restoName">{restaurantName}</div>
              {restaurantAddress && (
                <div className="line">{restaurantAddress}</div>
              )}
              {restaurantPhone && (
                <div className="line">Phone: {restaurantPhone}</div>
              )}
            </div>
            <div className="right">
              <LogoRow>
                <FaFileInvoice />
                <h2>Sales Report</h2>
              </LogoRow>
              <div className="line">
                Period: <strong>{fromDate}</strong> to <strong>{toDate}</strong>
              </div>
              <div className="line">
                Generated on: <strong>{generatedOn}</strong>
              </div>
            </div>
          </ReportHeader>
        </PdfHeaderCard>

        {loading ? (
          <Center>Loading…</Center>
        ) : filtered.length === 0 ? (
          <Center>{error || "No orders found."}</Center>
        ) : (
          <>
            <TableWrap>
              <Table>
                <thead>
                  <tr>
                    <th style={{ width: 80 }}>ID</th>
                    <th>Amount</th>
                    <th>Table</th>
                    <th>Date</th>
                    <th>Time</th>
                    <th style={{ width: 110 }}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {filtered.map((o) => (
                    <tr
                      key={o.id}
                      onClick={() => viewReceipt(o)}
                      style={{ cursor: "pointer" }}
                    >
                      <td>{o.id}</td>
                      <td>{fmtINR(o.totalamount)}</td>
                      <td>{o.tableid}</td>
                      <td>{fmtDate(o.created_at)}</td>
                      <td>{fmtTime(o.created_at)}</td>
                      <td onClick={(e) => e.stopPropagation()}>
                        <LinkBtn to={`/receipt/${o.id}`} state={{ order: o }}>
                          <FaEye /> View
                        </LinkBtn>
                      </td>
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr>
                    <td colSpan={1}>
                      <b>Totals</b>
                    </td>
                    <td>
                      <b>{fmtINR(totals.totalAmount)}</b>
                    </td>
                    <td colSpan={3}></td>
                  </tr>
                </tfoot>
              </Table>
            </TableWrap>

            {/* PDF Footer */}
            <PdfFooter>
              <span>Powered by</span>
              <strong>BillSarthi</strong>
            </PdfFooter>
          </>
        )}
      </Card>
    </Wrap>
  );
};

export default SalesListPage;

/* ---------------- styled ---------------- */
const Wrap = styled.div`
  font-family: system-ui, -apple-system, Segoe UI, Roboto, Inter, Arial;
  background: ${color.bg};
  min-height: 100vh;
  padding-bottom: 32px;
`;

const Header = styled.header`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  background: ${color.brand};
  color: #fff;
  padding: 12px 18px;
  position: sticky;
  top: 0;
  z-index: 5;
`;
const HeaderLeft = styled.button`
  justify-self: start;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: transparent;
  color: #fff;
  border: 0;
  font-weight: 700;
  cursor: pointer;
`;
const HeaderTitle = styled.h1`
  margin: 0;
  text-align: center;
  font-size: 1.2rem;
  letter-spacing: 0.3px;
  font-weight: 900;
`;
const HeaderRight = styled.div`
  justify-self: end;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`;
const ExportBtn = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: linear-gradient(135deg, var(--app-primary), var(--app-primary-hover));
  border: 0;
  color: #fff;
  padding: 8px 12px;
  border-radius: 10px;
  font-weight: 800;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(7, 95, 158, 0.2);
  transition: opacity 0.15s ease, transform 0.15s ease;

  &:hover:not(:disabled) {
    opacity: 0.92;
    transform: translateY(-1px);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

const Card = styled.div`
  background: ${color.white};
  border-radius: 16px;
  padding: 16px;
  margin: 16px;
  border: 1px solid ${color.line};
  box-shadow: 0 4px 16px rgba(2, 44, 77, 0.06);
`;
const CardTitle = styled.h2`
  margin: 2px 2px 12px;
  color: ${color.muted};
  font-size: 0.95rem;
  text-transform: uppercase;
  letter-spacing: 0.6px;
`;

const FiltersRow = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  @media (max-width: 860px) {
    grid-template-columns: 1fr;
  }
`;
const FilterBox = styled.div`
  display: grid;
  gap: 6px;
  label {
    color: ${color.text};
    font-weight: 700;
    display: flex;
    align-items: center;
    gap: 6px;
  }
  input {
    height: 44px;
    border: 1px solid ${color.line};
    border-radius: 10px;
    padding: 0 12px;
    background: #f9f9f9;
    color: ${color.text};
  }
`;
const SearchBox = styled.div`
  display: grid;
  gap: 6px;
  align-items: center;
  grid-template-columns: 20px 1fr;
  padding: 0 10px;
  border: 1px solid ${color.line};
  border-radius: 10px;
  background: #f9f9f9;
  color: ${color.text};
  input {
    height: 44px;
    border: 0;
    background: transparent;
    color: ${color.text};
    padding-left: 6px;
    font-size: 14px;
  }
`;

const QuickRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 10px;
  align-items: center;
`;
const QuickChip = styled.button`
  border: 1px solid ${color.line};
  background: ${({ $active }) => ($active ? color.brand : "#f5f7fb")};
  color: ${({ $active }) => ($active ? "#fff" : color.text)};
  border-radius: 999px;
  padding: 8px 12px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.15s ease;
  &:hover {
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.06);
  }
`;
const RefreshBtn = styled.button`
  border: 1px solid ${color.brand};
  background: ${color.brandSoft};
  color: ${color.brand};
  border-radius: 10px;
  padding: 8px 12px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-weight: 800;
  cursor: pointer;
`;

const SummaryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 12px;
  margin-top: 14px;
`;
const SummaryCard = styled.div`
  background: #f9fbff;
  border: 1px solid ${color.line};
  border-radius: 14px;
  padding: 14px;
  display: flex;
  align-items: center;
  gap: 12px;
  small {
    color: ${color.muted};
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.6px;
    font-size: 11px;
  }
  h3 {
    margin: 2px 0 0;
    font-size: 1.4rem;
    color: ${color.text};
  }
  span {
    color: ${color.muted};
    font-size: 0.9rem;
  }
  .icon {
    width: 42px;
    height: 42px;
    border-radius: 12px;
    display: grid;
    place-items: center;
    color: #fff;
    &.brand {
      background: ${color.brand};
    }
    &.green {
      background: ${color.success};
    }
    &.orange {
      background: ${color.orange};
    }
  }
`;

const Highlight = styled.div`
  margin-top: 10px;
  padding: 12px 14px;
  border-radius: 12px;
  background: #fff7ed;
  border: 1px solid #fed7aa;
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  .label {
    color: #9a3412;
    font-weight: 800;
  }
  .value {
    font-weight: 900;
    color: ${color.text};
  }
  .meta {
    color: ${color.muted};
  }
`;

/* ==== PDF Header / Footer ==== */
const PdfHeaderCard = styled.div`
  border-radius: 14px;
  border: 1px solid ${color.line};
  padding: 12px 14px;
  margin-bottom: 14px;
  background: linear-gradient(90deg, #ffffff, #f5fbff);
`;

const ReportHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  .left {
    min-width: 180px;
  }
  .restoName {
    font-size: 1.15rem;
    font-weight: 800;
    color: ${color.brand};
    margin-bottom: 4px;
  }
  .left .line {
    color: ${color.muted};
    font-size: 0.85rem;
  }
  .right {
    text-align: right;
  }
  .right .line {
    color: ${color.muted};
    font-size: 0.8rem;
  }
  @media (max-width: 720px) {
    flex-direction: column;
    .left {
      min-width: 0;
    }
    .right {
      text-align: left;
    }
  }
`;

const LogoRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: flex-end;
  h2 {
    margin: 0;
  }
`;

const PdfFooter = styled.div`
  margin-top: 14px;
  padding-top: 8px;
  border-top: 1px dashed ${color.line};
  text-align: center;
  font-size: 11px;
  color: ${color.muted};
  strong {
    color: ${color.brand};
    margin-left: 4px;
  }
`;

const TableWrap = styled.div`
  width: 100%;
  overflow-x: auto;
  border-radius: 12px;
  border: 1px solid ${color.line};
`;
const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  background: #fff;

  thead {
    background: ${color.brandSoft};
  }
  th,
  td {
    padding: 10px 12px;
    border-bottom: 1px solid ${color.line};
    text-align: left;
    font-size: 14px;
  }
  tbody tr:hover {
    background: #fafcff;
  }
  tfoot td {
    background: #fcfcff;
  }
`;

const Center = styled.div`
  text-align: center;
  padding: 40px;
  color: ${color.muted};
`;

const LinkBtn = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: ${color.brandSoft};
  border: 1px solid ${color.brand};
  color: ${color.brand};
  padding: 6px 10px;
  border-radius: 10px;
  font-weight: 800;
  text-decoration: none;
`;
